import { CrossIcon } from '@ui/kit/icons';
import { StateBox } from '../atom.state-box/_state-box.js';
import { stateBox, stateBoxContent, button } from './atom.cross.style.js';
import { jsx } from 'react/jsx-runtime';

function Cross(props) {
  if (props.state === "correct" || props.state === "incorrect" || props.state === "should-have" || props.state === "readonly") {
    return /*#__PURE__*/jsx(StateBox, {
      className: stateBox,
      state: props.state,
      textTheme: "colored",
      children: /*#__PURE__*/jsx("div", {
        "data-checked": props.checked,
        className: stateBoxContent,
        "data-state": props.state,
        children: /*#__PURE__*/jsx(CrossIcon, {
          height: 20,
          strokeWidth: 0.75
        })
      })
    });
  }
  return /*#__PURE__*/jsx("button", {
    className: button,
    "data-checked": props.checked,
    "data-state": props.state,
    onClick: props.onClick,
    children: /*#__PURE__*/jsx(CrossIcon, {
      height: 20,
      strokeWidth: 0.75
    })
  });
}

export { Cross };
//# sourceMappingURL=atom.cross.js.map
